import { gql } from '@apollo/client';

/**
 * Records a click on the pre-emptive ADVISORY banner (pay or dismiss), which also
 * advances that banner's server-side dismissal tri-state. Advisory only: the past-due
 * login popup is NOT recorded anywhere server-side. Its dismissal is sessionStorage
 * per account per browser session (`useDunningState`), by product decision.
 *
 * There is no matching read operation on purpose: dunning state is read from
 * `me.payment.dunning`, which the backend re-reads fresh from Mongo on every `me`
 * call. Adding a second source would reintroduce the staleness that fresh read
 * exists to prevent.
 *
 * `accountId` is taken from the caller's auth context server-side and is
 * deliberately NOT a parameter here.
 */
export const ACK_DUNNING_NOTICE = gql`
  mutation AckDunningNotice($payload: DunningAckInput!) {
    ackDunningNotice(payload: $payload) {
      recorded
    }
  }
`;

export interface AckDunningNoticeResult {
  ackDunningNotice: { recorded: boolean };
}

export interface AckDunningNoticeVariables {
  payload: {
    /** Ladder step being acknowledged, e.g. `notice3` or `cardExpiry`. */
    step: string;
    action: 'paid' | 'dismissed';
  };
}
